/* lisen-lagersalg.js
   Tilmeldingsformular. Markup kommer fra snippets/lisen-lagersalg-tilmeld.liquid.
   Sender direkte til Klaviyos client-side subscriptions-endpoint med
   det offentlige company_id. Ingen privat noegle i frontenden.
   custom_source bliver til $source paa profilen, og er derfor ogsaa
   det et Klaviyo-segment kan lytte efter. */
(function () {
  var REVISION = '2026-07-15';
  var STANDARD_TAK = 'Du er skrevet op. Du hører fra os på mail.';

  function init(rod) {
    if (!rod || rod.getAttribute('data-klar')) return;
    rod.setAttribute('data-klar', '1');

    var KONTO = rod.getAttribute('data-konto');
    var LISTE = rod.getAttribute('data-liste');
    var KILDE = rod.getAttribute('data-kilde');
    var TAK = rod.getAttribute('data-tak') || STANDARD_TAK;

    var form = rod.querySelector('.lisen-tilmeld__form');
    var indhold = rod.querySelector('.lisen-tilmeld__indhold');
    var knap = rod.querySelector('.lisen-tilmeld__knap');
    var besked = rod.querySelector('.lisen-tilmeld__besked');
    var navnFelt = rod.querySelector('[data-felt="fornavn"]');
    var emailFelt = rod.querySelector('[data-felt="email"]');
    var fnidder = rod.querySelector('[name="lisen_fnidder"]');
    if (!form) return;

    var knapTekst = knap ? knap.textContent : '';

    function markerFejl(felt, galt) {
      if (!felt) return;
      var input = felt.querySelector('input');
      if (galt) {
        felt.classList.add('lisen-tilmeld__felt--fejl');
        if (input) input.setAttribute('aria-invalid', 'true');
      } else {
        felt.classList.remove('lisen-tilmeld__felt--fejl');
        if (input) input.removeAttribute('aria-invalid');
      }
    }

    function visBesked(tekst, erFejl) {
      if (!besked) return;
      besked.textContent = tekst || '';
      besked.classList.toggle('lisen-tilmeld__besked--fejl', !!erFejl);
    }

    function gyldigEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    }

    function visTak(navn) {
      var h = document.createElement('div');
      h.className = 'lisen-tilmeld__tak';
      var t = document.createElement('h2');
      t.className = 'lisen-tilmeld__tak-titel';
      t.textContent = navn ? ('Tak, ' + navn + '!') : 'Tak!';
      var p = document.createElement('p');
      p.textContent = TAK;
      h.appendChild(t);
      h.appendChild(p);
      if (indhold) {
        indhold.innerHTML = '';
        indhold.appendChild(h);
        indhold.setAttribute('role', 'status');
      }
    }

    [navnFelt, emailFelt].forEach(function (felt) {
      if (!felt) return;
      var input = felt.querySelector('input');
      if (input) input.addEventListener('input', function () { markerFejl(felt, false); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      /* Bots udfylder honeypot-feltet. Vi lader som om alt gik godt. */
      if (fnidder && fnidder.value) { visTak(''); return; }

      var navnInput = navnFelt ? navnFelt.querySelector('input') : null;
      var emailInput = emailFelt ? emailFelt.querySelector('input') : null;
      var navn = navnInput ? navnInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';

      var fejl = false;
      if (!navn) { markerFejl(navnFelt, true); fejl = true; }
      if (!gyldigEmail(email)) { markerFejl(emailFelt, true); fejl = true; }
      if (fejl) {
        visBesked('', false);
        var foerste = rod.querySelector('.lisen-tilmeld__felt--fejl input');
        if (foerste) foerste.focus();
        return;
      }

      visBesked('', false);
      if (knap) { knap.disabled = true; knap.textContent = 'Sender …'; }

      var krop = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: KILDE,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: navn,
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } }
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: LISTE } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KONTO), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: REVISION },
        body: JSON.stringify(krop)
      })
        .then(function (svar) {
          if (svar.ok || svar.status === 202) { visTak(navn); return; }
          return svar.text().then(function (t) { throw new Error(svar.status + ' ' + t); });
        })
        .catch(function (err) {
          if (window.console && console.warn) console.warn('[lisen-tilmeld]', err);
          if (knap) { knap.disabled = false; knap.textContent = knapTekst; }
          visBesked('Tilmeldingen gik ikke igennem. Prøv igen om et øjeblik.', true);
        });
    });
  }

  function skan() {
    Array.prototype.forEach.call(document.querySelectorAll('.lisen-tilmeld'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', skan);
  } else {
    skan();
  }
  document.addEventListener('shopify:section:load', skan);
})();